import { PercentCondition } from "../PercentCondition/PercentCondition";
import { FaceControlConditionTypes } from "@/includes/types/FaceControl.types";

export class NameRtlCondition extends PercentCondition {
    constructor() {
        super(FaceControlConditionTypes.Name_rtl);
    }
}